import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPage.css';

function Cookies() {
  return (
    <div className="legal-page">
      <div className="legal-page__container">
        <h1>Cookieポリシー</h1>
        <p className="legal-page__updated">最終更新日: 2025年6月30日</p>

        <section>
          <h2>1. Cookieとは</h2>
          <p>Cookieとは、ウェブサイトがユーザーのデバイスに保存する小さなテキストファイルです。これにより、ウェブサイトはユーザーのデバイスを認識し、ユーザー体験を向上させるための情報を記憶することができます。</p>
        </section>

        <section>
          <h2>2. 当社が使用するCookieの種類</h2>
          <p>当社は以下の種類のCookieを使用しています：</p>

          <h3>2.1 必須Cookie</h3>
          <p>これらのCookieは、当社のサービスを適切に機能させるために必要なものです。ユーザー認証、セッション管理、セキュリティ確保などの基本的な機能に使用されます。</p>

          <h3>2.2 パフォーマンスCookie</h3>
          <p>これらのCookieは、ユーザーがサイトをどのように利用しているかについての情報を収集し、サイトのパフォーマンスを測定し改善するのに役立ちます。アクセス統計や、特に人気のあるページなどの情報を提供します。</p>

          <h3>2.3 機能性Cookie</h3>
          <p>これらのCookieは、ユーザーの選択や設定（地域設定など）を記憶し、次回訪問時に同じ体験を提供するために使用されます。</p>

          <h3>2.4 ターゲティングCookie</h3>
          <p>これらのCookieは、ユーザーの閲覧履歴に基づいてカスタマイズされた広告を表示するために使用されます。これにより、ユーザーの興味や関心に合わせた広告を配信することができます。</p>

          <h3>2.5 サードパーティCookie</h3>
          <p>当社のウェブサイトには、分析ツールやソーシャルメディアプラットフォームなどのサードパーティが提供するCookieが含まれている場合があります。これらのCookieは当該サードパーティのプライバシーポリシーの対象となります。</p>
        </section>

        <section>
          <h2>3. Cookieの管理方法</h2>
          <p>ほとんどのウェブブラウザは、Cookieを受け入れるように初期設定されていますが、ブラウザの設定を変更することでCookieをブロックまたは削除することができます。ブラウザごとのCookie管理方法は以下の通りです：</p>
          <ul>
            <li><strong>Google Chrome:</strong> 設定 &gt; プライバシーとセキュリティ &gt; Cookieと他のサイトデータ</li>
            <li><strong>Mozilla Firefox:</strong> オプション &gt; プライバシーとセキュリティ &gt; Cookie</li>
            <li><strong>Safari:</strong> 環境設定 &gt; プライバシー &gt; Cookie</li>
            <li><strong>Microsoft Edge:</strong> 設定 &gt; Cookieとサイトのアクセス許可 &gt; Cookieとサイトデータの管理と削除</li>
          </ul>
          <p>ただし、Cookieをブロックまたは削除すると、当社のサービスの一部の機能が正常に動作しなくなる場合がありますので、ご注意ください。</p>
        </section>

        <section>
          <h2>4. ポリシーの変更</h2>
          <p>当社は、必要に応じて本Cookieポリシーを変更することがあります。変更があった場合は、本サービス上で通知します。</p>
        </section>

        <section>
          <h2>5. 連絡先</h2>
          <p>本Cookieポリシーに関するご質問やお問い合わせは、<a href="mailto:support@deli-ns.com">support@deli-ns.com</a>までご連絡ください。</p>
        </section>

        <div className="legal-page__footer">
          <Link to="/" className="legal-page__back">ホームに戻る</Link>
        </div>
      </div>
    </div>
  );
}

export default Cookies; 